import { Link } from 'react-router-dom'
import './../styles/HeaderLogged.css'
import Swal from 'sweetalert2'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { callAuthDelete } from '../actions/app'

const HeaderLogged = ({ callAuthDelete, profile, name }) => {
    profile = profile ? profile : 'admin'
    const menu = {
        none: [],
        admin: [
            {
                label: 'Cadastros',
                child: [
                    {
                        label: 'Usuário',
                        to: '/users',
                        icon: 'fas fa-user'
                    },
                    {
                        label: 'Empresas',
                        to: '/companies',
                        icon: 'fas fa-building'
                    },
                    {
                        label: 'Locais',
                        to: '/locations',
                        icon: 'fas fa-map'
                    },
                ]
            },
            {
                label: 'Checks',
                child: [
                    {
                        label: 'Checks Operacional',
                        to: '/checks-initialize',
                        icon: 'fas fa-cog'
                    },
                    {
                        label: 'Relatório',
                        to: '/checks',
                        icon: 'fas fa-cog'
                    },
                ]
            },
            {
                label: 'Configurações',
                child: [
                    {
                        label: 'Tipos de Local',
                        to: '/location-categories',
                        icon: 'fas fa-cog'
                    },
                    {
                        label: 'Regiões',
                        to: '/regions',
                        icon: 'fas fa-cog'
                    },
                ]
            }
        ],
        customer: [
            {
                label: 'Checks',
                child: [
                    {
                        label: 'Relatório',
                        to: '/checks',
                        icon: 'fas fa-cog'
                    },
                ]
            }
        ],
        technician: [
            {
                label: 'Checks',
                child: [
                    {
                        label: 'Relatório',
                        to: '/checks',
                        icon: 'fas fa-cog'
                    },
                ]
            }
        ],
        monitoring: [
            {
                label: 'Checks Operacional',
                to: '/checks-initialize',
                icon: 'fas fa-cog'
            },
            {
                label: 'Relatório',
                to: '/checks',
                icon: 'fas fa-cog'
            },
        ],
    }

    const logout = () => {
        Swal.fire({
            title: 'Deseja se desconectar do sistema?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callAuthDelete()
            }
        })
    }

    const sizeSubMenu = (item) => {
        const size = item.size ?? ''
        return size;
    }

    return (
        <header className='px-4'>
            <div className="logo">
                <Link to={'/'} className='d-block'><img src="/assets/img/logo.png" alt="Espartaco Soluções - Telemetria" className='img-fluid' /></Link>
            </div>
            <div className='menus ml-4 d-flex flex-fill'>
                {menu[profile].map((a, ai) => (
                    <div className='menus-item' key={ai}>
                        <span className='cursor-pointer'>{a.label}</span>
                        <div className={`menus-sub ${sizeSubMenu(a)}`}>
                            <div className='menus-sub-items'>
                                {a.child.map((b, bi) => (<Link key={bi} to={b.to}><i className={b.icon}></i>{b.label}</Link>))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className='icons d-flex justify-content-end'>
                <div className='icons-item notification mr-3 cursor-pointer'>
                    <i className='fas fa-bell fa-2x'></i>
                </div>
                <div className='icons-item profile mr-3 cursor-pointer'>
                    <i className='fas fa-user fa-2x'></i>
                    <span>{name}</span>
                </div>
                <div className='icons-item logout cursor-pointer' onClick={logout}>
                    <i className='fas fa-sign-out-alt fa-2x'></i>
                </div>
            </div>
        </header>
    )
}

const mapStateToProps = ({ app: { session } }) => ({
    profile: session.profile,
    name: session.name
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            callAuthDelete
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogged)